import { SignInPage } from '@backstage/core-components';
import {
  configApiRef,
  useApi,
  type SignInPageProps,
} from '@backstage/core-plugin-api';
import { oktaProvider } from '../../components/auth/signInProviders';
import { OktaRedirectSignInPage } from '../../components/auth/OktaRedirectSignInPage';

export const AppSignInPage = (props: SignInPageProps) => {
  const configApi = useApi(configApiRef);
  // auth.environment is @visibility frontend in the upstream Backstage schema.
  // Set in app-config.k8s.yaml (production) and app-config.local.test.yaml
  // when Okta dev credentials are configured (FR-016).
  // Not set → local dev without Okta → fall back to guest.
  const authEnvironment = configApi.getOptionalString('auth.environment');
  if (authEnvironment === 'production') {
    // Break-glass: show guest alongside Okta when auth.guestFallback is set
    // (e.g., during Okta outages). Remove auth.guestFallback once Okta is stable.
    if (configApi.getOptionalBoolean('auth.guestFallback')) {
      return <SignInPage {...props} providers={[oktaProvider, 'guest']} />;
    }
    // Normal production: send the visitor straight to Okta in this tab, no
    // guest fallback and no provider-picker. Requires the root-level
    // `enableExperimentalRedirectFlow: true` in app-config.k8s.yaml.
    return <OktaRedirectSignInPage {...props} />;
  }
  if (authEnvironment === 'development') {
    // Local dev with Okta configured: show both options so developers
    // without Okta credentials can still sign in as guest.
    return <SignInPage {...props} providers={[oktaProvider, 'guest']} />;
  }
  // No auth.environment: guest-only, auto-signed in silently.
  return <SignInPage {...props} providers={['guest']} />;
};
